<template>
    <video
        :key="`block-type-video-static-${videoSrc}`"
        :class="cssClass"
        :style="cssStyle"
        :aria-description="config.base.altText ?? ''"
        :poster="posterImg"
        playsinline
        autoplay
        muted
        loop
    >
        <source
            :src="videoSrc"
            type="video/mp4"
        >
        <track kind="captions">
    </video>
</template>

<script lang="ts" setup>
    import type {
        ContentBlocksComponentProps,
        ContentBlockVideoStatic,
        ContentBlockThemeStyleItems,
    } from '~/types';
    import { legacyContentHelpers } from '~/composables';
    import {
        useCdnResource
    } from 'x1-base/composables';

    const props = withDefaults(
        defineProps<ContentBlocksComponentProps<ContentBlockVideoStatic>>(),
        {
            theme: 'light',
            breakpoint: 'desktop',
            breakpointName: 'md'
        }
    );

    const { getBreakpointItem } = legacyContentHelpers;
    const videoSrc = computed(() => props.isMobile ? props.config.base.videoUrlMobile : props.config.base.videoUrlDesktop);
    const useCdnResourceObj = useCdnResource();
    const cssClass = ref<string[]>([]);
    const cssStyle = ref<Record<string, string>>({});
    const posterImg = computed<string>(() => {
        let url = '';
        const srcObj = props.config.theme?.[props.theme].srcset?.[0];

        if (srcObj) {
            url = srcObj.isCdn ? useCdnResourceObj.getResourceCdnUrl(srcObj.url) : srcObj.url;
        }

        return url;
    });

    const unWatchTheme = watch(
        () => props.breakpointName,
        (newBreakpointName) => {
            const config = getBreakpointItem<ContentBlockThemeStyleItems>(
                newBreakpointName,
                props.config.component?.breakpoint
            );

            if (config) {
                cssClass.value = config.cssClass ?? [];
                cssStyle.value = config.cssStyle ?? {};
            }
        },
        {
            immediate: true
        }
    );

    onBeforeUnmount(() => {
        unWatchTheme();
    });
</script>

<style lang="scss"></style>
